import React from 'react';
import AppLayout from '../layout/AppLayout';
import ManagementPageSkeleton from '../layout/ManagementPageSkeleton';
import PermissionProtectedRoute from './PermissionProtectedRoute';

const ManagementRoute = ({
  pageTitle,
  pageSubtitle,
  skeletonVariant,
  children,
  ...permissionProps
}) => {
  const layout = (
    <AppLayout pageTitle={pageTitle} pageSubtitle={pageSubtitle}>
      {children}
    </AppLayout>
  );

  const loadingFallback = pageTitle ? (
    <AppLayout pageTitle={pageTitle} pageSubtitle={pageSubtitle}>
      <ManagementPageSkeleton
        pageTitle={pageTitle}
        pageSubtitle={pageSubtitle}
        variant={skeletonVariant}
      />
    </AppLayout>
  ) : undefined;

  return (
    <PermissionProtectedRoute loadingFallback={loadingFallback} {...permissionProps}>
      {layout}
    </PermissionProtectedRoute>
  );
};

export default ManagementRoute;
